import Grid2 from "@mui/material/Unstable_Grid2";
import { useDomesticMarketSpreadPriceProducerContext } from "../../../../../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceProducerContext";
import { CustomAutocomplete } from "../../../../../components/custom/CustomAutocomplete";
import { Box, Typography } from "@mui/material";
import { LooksTwo } from "@mui/icons-material";
import { COLORS } from "../../../../../ui/Theme";

const CommodityForm2 = () => {
  const {
    companies2,
    groups2,
    commodities2,
    inputProducerValues2,
    setInputProducerValues2,
  } = useDomesticMarketSpreadPriceProducerContext();

  const { company, group, commodity } = inputProducerValues2;

  const clearForm = (field) => {
    switch (field) {
      case "company":
        setInputProducerValues2((prev) => ({
          ...prev,
          group: null,
          commodity: null,
        }));
        break;
      case "group":
        setInputProducerValues2((prev) => ({
          ...prev,
          commodity: null,
        }));
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 900,
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "center", md: "flex-start" },
          gap: 0.5,
        }}
      >
        کالا
        <LooksTwo sx={{ color: COLORS.BLUE }} />
      </Typography>

      <Grid2 container spacing={"10px"}>
        <Grid2 xs={12} md={4}>
          <CustomAutocomplete
            options={companies2.data}
            value={company}
            onChange={(e, newValue) => {
              setInputProducerValues2((prev) => ({
                ...prev,
                company: newValue,
              }));
              clearForm("company", newValue);
            }}
            isLoading={companies2.isLoading}
            placeholder="شرکت"
          />
        </Grid2>
        <Grid2 xs={12} md={4}>
          <CustomAutocomplete
            options={groups2.data}
            value={group}
            onChange={(e, newValue) => {
              setInputProducerValues2((prev) => ({ ...prev, group: newValue }));
              clearForm("group", newValue);
            }}
            isLoading={groups2.isLoading}
            placeholder="گروه"
          />
        </Grid2>
        <Grid2 xs={12} md={4}>
          <CustomAutocomplete
            options={commodities2.data}
            value={commodity}
            onChange={(e, newValue) => {
              setInputProducerValues2((prev) => ({
                ...prev,
                commodity: newValue,
              }));
              clearForm("commodity", newValue);
            }}
            isLoading={commodities2.isLoading}
            placeholder="کالا (اختیاری)"
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default CommodityForm2;
